require('./bootstrap');
require('lightbox2');
require('lightbox2/src/css/lightbox.css');
require('js-datepicker/src/datepicker.scss');

import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import Swal from 'sweetalert2';
import datepicker from 'js-datepicker';
import Chart from 'chart.js';

$(document).ready(function()
{
  $('form').bind("keypress", function(e) {
    if (e.keyCode == 13) {
      e.preventDefault();
      return false;
    }
  });

  $('.js-delete').click(function(e){
      e.preventDefault()
      if (confirm('Are you sure?')) {
          $(e.target).closest('form').submit() // Post the surrounding form
      }
  });

  if($('.dataTable').length > 0)
  {
    $('.dataTable').DataTable({
      "pageLength": 100
    });
  }

  var calendarEl = document.getElementById('calendar');

  if(calendarEl !== null)
  {
    var calendarQuery = '';
    var calendarView  = 'dayGridWeek';

    if($('#calendar').data('fitter'))
    {
      calendarQuery = '?fitter_id='+$('#calendar').data('fitter');
      // calendarView  = 'dayGridMonth';
    }

    const calendar = new Calendar(calendarEl, {
      plugins: [ dayGridPlugin ],
      initialView: calendarView,
      eventOrder: "-color",
      timeZone: 'local',
      eventSources: [
        {
          url: '/json/calendar'+calendarQuery, // use the `url` property
          textColor: '#FFF'  // an option!
        }
      ],
      eventClick: function(info) {
        console.log(info.event.extendedProps);
        Swal.fire({
          icon: 'info',
          title: info.event.extendedProps.agreement.name,
          html: '<table class="table"><tr><td>Name</td><td>'+info.event.extendedProps.agreement.name+'</td></tr><tr><td>Mobile</td><td>'+info.event.extendedProps.agreement.mobile+'</td></tr><tr><td>Address</td><td>'+info.event.extendedProps.agreement.address_number+' '+info.event.extendedProps.agreement.address+'</td></tr></table>',
          footer: '<a href="/customer/'+info.event.extendedProps.agreement.id+'" class="btn btn-primary">View this listing</a>'
        })
      }
    });

    calendar.render();

    if($('#calendar').data('date'))
    {
      var goToDate = new Date($('#calendar').data('date'));
      console.log(goToDate);
      calendar.gotoDate(goToDate);
    }

    if($('#date_of_fitting').length > 0)
    {
      var picker = datepicker('#date_of_fitting', {
        onSelect: (instance, date) => {
          $('#booking_date').val(date.getTime());

          var currentBooking = calendar.getEventById('NEWBOOKING');

          if(currentBooking)
          {
            currentBooking.remove();
          }

          calendar.addEvent({
            id: 'NEWBOOKING',
            title:"NEW BOOKING",
            allDay: true,
            start: date,
            end: date
          });
          calendar.gotoDate(date);
        }
      });
    }
  }

  var leadCalendarEl = document.getElementById('leadCalendar');

  if(leadCalendarEl !== null)
  {
    var calendarQuery = '';
    var calendarView  = 'dayGridWeek';

    if($('#leadCalendar').data('user'))
    {
      calendarQuery = '?user_id='+$('#leadCalendar').data('user');
      // calendarView  = 'dayGridMonth';
    }

    const calendar = new Calendar(leadCalendarEl, {
      plugins: [ dayGridPlugin ],
      initialView: calendarView,
      eventOrder: "-color",
      timeZone: 'local',
      headerToolbar: {
        left: 'prev,next',
        center: 'title',
        right: 'dayGridDay,dayGridWeek'
      },
      eventSources: [
        {
          url: '/json/calendar-leads'+calendarQuery, // use the `url` property
          textColor: '#000'  // an option!
        }
      ],
      eventRender: function(event, element) {
        element.css("font-size", "1.2em");
        element.css("padding", "5px");
      },
      eventClick: function(info) {
        Swal.fire({
          icon: 'info',
          title: info.event.extendedProps.lead.name,
          html: '<table class="table"><tr><td>Name</td><td>'+info.event.extendedProps.lead.name+'</td></tr><tr><td>Status</td><td>'+info.event.extendedProps.lead.status+'</td></tr><tr><td>Appointment Date</td><td>'+info.event.extendedProps.lead.appointment_date_text+'</td></tr><tr><td>Email</td><td>'+info.event.extendedProps.lead.email+'</td></tr><tr><td>Mobile</td><td>'+info.event.extendedProps.lead.mobile+'</td></tr><tr><td>Postcode</td><td>'+info.event.extendedProps.lead.postcode+'</td></tr><tr><td>Address</td><td>'+info.event.extendedProps.lead.address_number+' '+info.event.extendedProps.lead.address+'</td></tr></table><a href="/sales/lead/'+info.event.extendedProps.lead.id+'?action=15" class="btn btn-warning" style="border: solid 1px #000;background-color: #00bf92;color: #FFF;">Confirm Appointment</a>',
          showCancelButton: true,
          showCloseButton: true,
          confirmButtonText: `Open Lead`,
        }).then((result) => {
          if (result.isConfirmed) {
            if(info.event.extendedProps.lead.status == 'Converted')
            {
              alert('This lead has been converted. You cannot open this now.')
            } else {
              window.location = '/sales/lead/'+info.event.extendedProps.lead.id;
            }
          }
        })
      }
    });

    calendar.render();
  }

  var leadCalendarAdminEl = document.getElementById('leadCalendarAdmin');

  if(leadCalendarAdminEl !== null)
  {
    var calendarQuery = '';
    var calendarView  = 'dayGridWeek';

    if($('#leadCalendarAdmin').data('user'))
    {
      calendarQuery = '?user_id='+$('#leadCalendarAdmin').data('user');
      // calendarView  = 'dayGridMonth';
    }

    const calendar = new Calendar(leadCalendarAdminEl, {
      plugins: [ dayGridPlugin ],
      initialView: calendarView,
      eventOrder: "-color",
      timeZone: 'local',
      eventSources: [
        {
          url: '/json/calendar-leads'+calendarQuery, // use the `url` property
          textColor: '#000'  // an option!
        }
      ],
      eventClick: function(info) {
        console.log(info.event.extendedProps);
        Swal.fire({
          icon: 'info',
          title: info.event.extendedProps.lead.name,
          html: '<table class="table"><tr><td>Name</td><td>'+info.event.extendedProps.lead.name+'</td></tr><tr><td>Mobile</td><td>'+info.event.extendedProps.lead.mobile+'</td></tr><tr><td>Address</td><td>'+info.event.extendedProps.lead.address+' '+info.event.extendedProps.lead.postcode+'</td></tr></table>',
          footer: '<a href="/lead/'+info.event.extendedProps.lead.id+'" class="btn btn-primary">View this lead</a>'
        })
      },
      eventDidMount: function(view, element){
        console.log(view.view.getCurrentData().calendarApi.currentData.dateProfile.currentRange.start);
        var currentdate = view.view.getCurrentData().calendarApi.currentData.dateProfile.currentRange.start;

        console.log(currentdate);

        if($('#weekStart').length > 0)
        {
          $('#weekStart').val(new Date(currentdate).toLocaleDateString('en-GB'));
        }
      }
    });

    calendar.render();
  }

  if($('#date').length > 0)
  {
    var picker = datepicker('#date', {
      minDate: new Date(),
      onSelect: (instance, date) => {
        $('#date_value').val(date.getTime());
      }
    });
  }
  if($('#todo_date').length > 0)
  {
    var picker = datepicker('#todo_date', {
      minDate: new Date(),
      onSelect: (instance, date) => {
        $('#todo_date_value').val(date.getTime());
      }
    });
  }
  if($('#fitter_date_search').length > 0)
  {
    var picker = datepicker('#fitter_date_search', {
      minDate: new Date(),
      onSelect: (instance, date) => {
        $('#fitter_date_search_value').val(date.getTime());
      }
    });
  }
  if($('#week_start').length > 0)
  {
    var picker = datepicker('#week_start', {
      minDate: new Date(),
      onSelect: (instance, date) => {
        $('#week_start_value').val(date.getTime());
      }
    });
  }
  if($('#payments_from').length > 0)
  {
    var picker = datepicker('#payments_from', {
      minDate: new Date(),
      onSelect: (instance, date) => {
        $('#payments_from_value').val(date.getTime());
      }
    });
  }
  if($('#payments_to').length > 0)
  {
    var picker = datepicker('#payments_to', {
      minDate: new Date(),
      onSelect: (instance, date) => {
        $('#payments_to_value').val(date.getTime());
      }
    });
  }

  if($('#reportChart').length > 0)
  {
    var labels  = $('#reportChart').data('labels').split(',');
    var auth    = $('#reportChart').data('auth').split(',');
    var dec     = $('#reportChart').data('dec').split(',');

    var ctx = $('#reportChart');
    var myChart = new Chart(ctx, {
        type: 'line',
        data: {
          labels: labels,
          datasets: [
            {
              label: 'AUTHORISED PAYMENTS',
              data: auth,
              backgroundColor: [
                  'rgba(32, 169, 31, 0.2)'
              ],
              borderColor: [
                  'rgba(32, 169, 31, 1)'
              ],
              borderWidth: 1
            },
            {
              label: 'DECLINED PAYMENTS',
              data: dec,
              backgroundColor: [
                  'rgba(169, 31, 31, 0.2)'
              ],
              borderColor: [
                  'rgba(169, 31, 31, 1)'
              ],
              borderWidth: 1
            }
          ]
        }
    });
  }
});
